import { Icon } from "@iconify/react";
import { createFileRoute, Link } from "@tanstack/react-router";
import { useTranslations } from "use-intl";
import { recordQuizParticipation } from "$/modules/exam/lib/exam";
import { useQuizPlayer } from "$/modules/shared/provider/quiz-player-provider";
import { Button } from "$/modules/shared/ui/button";
import {
	Card,
	CardContent,
	CardFooter,
	CardHeader,
} from "$/modules/shared/ui/card";

export const Route = createFileRoute(
	"/$locale/quiz-player/$projectId/welcome/",
)({
	component: WelcomePage,
});

function WelcomePage() {
	const { project, questionnaires } = useQuizPlayer();

	const t = useTranslations("quiz");
	const recordParticipation = () => {
		const key = `quizfy-participation:${project.$id}`;
		let sessionId = window.localStorage.getItem(key);
		if (!sessionId) {
			sessionId = crypto.randomUUID();
			window.localStorage.setItem(key, sessionId);
		}
		void recordQuizParticipation(project.$id, sessionId);
	};

	return (
		<div className="min-h-screen w-full flex items-center justify-center p-4 sm:p-6">
			<Card className="w-full max-w-xl border border-default-200">
				<CardHeader>
					<h1 className="w-full text-center text-2xl font-bold sm:text-3xl md:mb-4">
						{t("title")}
					</h1>
				</CardHeader>
				<CardContent className="space-y-4 md:space-y-8">
					<p className="mx-auto max-w-md text-center text-sm sm:text-base">
						{t.rich("welcome", {
							highlight: (chunks) => (
								<span className="text-primary text-lg sm:text-xl">
									{chunks}
								</span>
							),
							questionAmount:
								questionnaires?.flatMap((q) => q.questions).length || 0,
							questionnaireAmount: questionnaires?.length || 0,
						})}
					</p>
				</CardContent>
				<CardFooter>
					<Button
						asChild
						className="w-full"
						onClick={recordParticipation}
						variant="default"
					>
						<Link
							className="w-full"
							to="/$locale/quiz-player/$projectId/questionnaires"
							params={{
								locale: Route.useParams().locale,
								projectId: Route.useParams().projectId,
							}}
						>
							{t("start")}
							{<Icon icon="lucide:tv-minimal-play" className="size-5" />}
						</Link>
					</Button>
				</CardFooter>
			</Card>
		</div>
	);
}
